import artifact from '$houdini/artifacts/CreateReportQueueJob'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateReportQueueJobStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
